/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface ClickShowRequestItineraryArrangementsParams {
  path: string;
}

/**
 * 発火タイミング：旅程ページの固定CTA「Request itinerary arrangements」押下時
 */
export const sendGAWabunkaClickShowRequestItineraryArrangementsEvent = (path: string) => {
  sendWabunkaGAEvent('click_show_request_itinerary_arrangements', { path });
};
